import React from "react";
import { PageHeader, MyTextInput } from "@excoleadershipui/pionweblib";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
// material ui
import {
  Card,
  CardHeader,
  IconButton,
  Grid,
  Box,
  CardContent,
} from "@mui/material";
// icons
import CancelIcon from "@mui/icons-material/Cancel";
// components
import { FormSubmitButton, CommonCurdPopUp,MuiAutocomplete } from "../../../../components";
import Notifier from "../../../../components/common/Notifier";
import ErrorNotifier from "../../../../components/common/ErrorNotifier";
// redux
import {
  updateQuestionType,
  getQuestionType,
  resetMessage,
  resetErrMessage,
} from "../../../../features/config/questionTypeSlice";

// --------------------------------------------------------------

const validationSchema = Yup.object({
  questionType: Yup.string().required("Question Type is required"),
  responseType: Yup.string().required("Response Type is required"),
  comments: Yup.string(),
});

//   ------------------------------------------------------------------------------------------

const UpdateQuestionType = (props) => {
  const { message, errMessage, selectedData } = useSelector(
    (state) => ({ ...state.questionType })
  );

  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      questionType: selectedData?.questionTypeName,
      responseType: selectedData?.responseType,
      comments: selectedData?.comments,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      dispatch(
        updateQuestionType({
          id: selectedData.id,
          questionTypeName: values.questionType,
          responseType: values.responseType,
          comments: values.comments,
        })
      ).then((res) => {
        if (res?.payload?.data?.ok) {
          setTimeout(() => {
            dispatch(resetMessage());
            props.close();
            dispatch(getQuestionType());
          }, 2000);
        }
        if (res?.payload?.error) {
          setTimeout(() => {
            dispatch(resetErrMessage());
          }, 3000);
        }
      });
    },
  });

  return (
    <>

      {props?.showEdit && <CommonCurdPopUp
        heading={`Update Account Mapping`}
        mediumScreen={true}
        close={props.close}
      >
        <Grid container >
          <Grid item xs={12} sm={12} md={0.5} lg={0.5}></Grid>
          <Grid item xs={12} sm={12} md={11} >
            <Grid item xs={12} sm={12} md={12}>
              <MuiAutocomplete

                name="custName"
                options={[]}
                setValue={(name, newValue) => {

                  formik.setFieldValue(name, newValue)
                  // formik.setFieldValue("account", "")

                }
                }
                value={formik.values.custName}
                optionValue="customerName"
                label="Account Name"
                required={true}
                error={formik.touched.custName && Boolean(formik.errors.custName)}
                helperText={formik.touched.custName && formik.errors.custName}
              />
            </Grid>
          </Grid>
          <Box style={{ width: "100%", textAlign: "center" }} >

            <FormSubmitButton onClick={formik?.handleSubmit} type="submit" variant="contained">
              Submit
            </FormSubmitButton>
          </Box>
        </Grid>

      </CommonCurdPopUp>}
      {message && <Notifier message={message} />}
      {errMessage && <ErrorNotifier message={errMessage} />}

    </>
  );
};

export default UpdateQuestionType;
